import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion'
import {
  PiBriefcaseLight,
  PiCurrencyDollarLight,
  PiLaptopLight,
  PiRulerLight,
  PiAtomLight,
  PiHandshakeLight,
  PiScalesLight,
  PiBookOpenLight,
  PiMaskHappyLight,
  PiStethoscopeLight,
  PiHeartbeatLight,
  PiShieldCheckLight,
  PiChefHatLight,
  PiBroomLight,
  PiHandHeartLight,
  PiShoppingCartLight,
  PiOfficeChairLight,
  PiPlantLight,
  PiHardHatLight,
  PiWrenchLight,
  PiFactoryLight,
  PiTruckLight,
  PiTargetLight,
  PiCaretLeftLight,
  PiCaretRightLight,
} from 'react-icons/pi'
import { HiAdjustmentsHorizontal } from 'react-icons/hi2';
import { ProductsContext } from '../context/products.context';
const iconMapping = {
  "11": PiBriefcaseLight,
  "13": PiCurrencyDollarLight,
  "15": PiLaptopLight,
  "17": PiRulerLight,
  "19": PiAtomLight,
  "21": PiHandshakeLight,
  "23": PiScalesLight,
  "25": PiBookOpenLight,
  "27": PiMaskHappyLight,
  "29": PiStethoscopeLight,
  "31": PiHeartbeatLight,
  "33": PiShieldCheckLight,
  "35": PiChefHatLight,
  "37": PiBroomLight,
  "39": PiHandHeartLight,
  "41": PiShoppingCartLight,
  "43": PiOfficeChairLight,
  "45": PiPlantLight,
  "47": PiHardHatLight,
  "49": PiWrenchLight,
  "51": PiFactoryLight,
  "53": PiTruckLight,
  "55": PiTargetLight,
}

const majorGroupMapping = {
  "11": "Management Occupations",
  "13": "Business and Financial Operations Occupations",
  "15": "Computer and Mathematical Occupations",
  "17": "Architecture and Engineering Occupations",
  "19": "Life, Physical, and Social Science Occupations",
  "21": "Community and Social Service Occupations",
  "23": "Legal Occupations",
  "25": "Educational Instruction and Library Occupations",
  "27": "Arts, Design, Entertainment, Sports, and Media Occupations",
  "29": "Healthcare Practitioners and Technical Occupations",
  "31": "Healthcare Support Occupations",
  "33": "Protective Service Occupations",
  "35": "Food Preparation and Serving Related Occupations",
  "37": "Building and Grounds Cleaning and Maintenance Occupations",
  "39": "Personal Care and Service Occupations",
  "41": "Sales and Related Occupations",
  "43": "Office and Administrative Support Occupations",
  "45": "Farming, Fishing, and Forestry Occupations",
  "47": "Construction and Extraction Occupations",
  "49": "Installation, Maintenance, and Repair Occupations",
  "51": "Production Occupations",
  "53": "Transportation and Material Moving Occupations",
  "55": "Military Specific Occupations",
}

const shortMajorMapping = {
  "11": "Mgmt",
  "13": "Biz/Finance",
  "15": "Comp/Math",
  "17": "Arch/Eng",
  "19": "Sciences",
  "21": "Social Svc",
  "23": "Legal",
  "25": "Education",
  "27": "Arts/Media",
  "29": "Healthcare",
  "31": "Health Sup",
  "33": "Protective",
  "35": "Food",
  "37": "Bldg/Grounds",
  "39": "Personal Svc",
  "41": "Sales",
  "43": "Office/Admin",
  "45": "Farming",
  "47": "Construction",
  "49": "Install/Repair",
  "51": "Production",
  "53": "Transport",
  "55": "Military",
}

function shortenMajorName(fullName) {
  return fullName.replace(/ Occupations$/i, '').trim()
}

export default function BookmarkRail(props){

  const { isOpen } = useContext(ProductsContext);
  const { bookmarks = [], activeMajor, onJump, hidden = false } = props;
  
  const [isExpanded, setIsExpanded] = useState(false)
  const collapsedWidth = 60
  const expandedWidth = 170
  const itemHeight = 34

  const activeIndex = bookmarks.findIndex((b) => b.major === activeMajor)
  const activeLineTop = activeIndex !== -1 ? activeIndex * itemHeight : 0

  // Animate width based on `hidden` and `isOpen`
  const animateWidth = hidden
    ? 0
    : isOpen       // If the filter panel is open, collapse the rail.
      ? collapsedWidth
      : isExpanded
        ? expandedWidth
        : collapsedWidth;

  return (
    <motion.div
      className="bg-white flex-shrink-0"
      initial={{ width: collapsedWidth }}
      animate={{ width: animateWidth }}
      transition={{ duration: 0.3 }}
      style={{ height: '50vh' }}
    >
      <div className="flex flex-col relative h-[750px] mt-[125px] pr-2">
        <div
          className="flex-shrink-0 flex items-center justify-center cursor-pointer p-2 bg-gray-50 hover:bg-gray-100 border-b border-gray-300"
          onClick={() => setIsExpanded((prev) => !prev)}
          title="Toggle Sidebar"
        >
          {isExpanded ? (
            <PiCaretLeftLight size={20} className="text-gray-600" />
          ) : (
            <PiCaretRightLight size={20} className="text-gray-600" />
          )}
        </div>
        <div className="relative flex-1 overflow-auto">
          {activeIndex !== -1 && (
            <motion.div
              className="absolute bg-orange-500"
              initial={{ top: 0 }}
              animate={{ top: activeLineTop }}
              transition={{ duration: 0.3 }}
              style={{
                left: 0,
                right: 0,
                height: '1px',
                zIndex: 1,
                position: 'absolute',
              }}
            />
          )}
          <div className="flex flex-col">
            {bookmarks.map((bm) => {
              const { major, index } = bm
              const twoDigits = major.slice(0, 2)
              const isActive = major === activeMajor
              const fullName = majorGroupMapping[twoDigits] || 'Unknown'
              const shortName = shortMajorMapping[twoDigits] || shortenMajorName(fullName)
              const IconComponent = iconMapping[twoDigits] || PiBriefcaseLight
              return (
                <div
                  key={major}
                  onClick={() => onJump(index)}
                  className={`group cursor-pointer flex items-center transition-colors duration-200 
                    ${isExpanded ? 'px-2' : 'justify-center'} 
                    ${!isActive ? 'hover:bg-gray-100' : ''} 
                    ${isActive ? 'bg-amber-50 rounded-none' : 'bg-white rounded-md'}`}
                  style={{ height: itemHeight }}
                  title={fullName}
                >
                  <IconComponent
                    size={22}
                    className={`transition-colors duration-200 ${isActive ? 'text-orange-500' : 'text-gray-700'}`}
                  />
                  {isExpanded && (
                    <div>
                      <span
                        className={`tabular-nums font-sans text-xs font-extralight whitespace-nowrap border-l mx-1 px-1 ${isActive ? 'border-orange-500' : 'border-gray-300'}`}
                        style={{ color: isActive ? '#f97316' : '#374151' }}
                      >
                        {`${twoDigits}.`}
                      </span>
                      <span
                        className="text-sm font-medium truncate transition-colors duration-200"
                        style={{ color: isActive ? '#f97316' : '#374151' }}
                      >
                        {shortName}
                      </span>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </motion.div>
  )
}